import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RegistrationData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  selectedTierId: number;
  billingCycle: 'monthly' | 'annual';
  emailVerified: boolean;
  trialStartDate?: string;
  trialEndDate?: string;
}

interface RegistrationStore {
  registrationData: RegistrationData | null;
  setRegistrationData: (data: Partial<RegistrationData>) => void;
  updateEmailVerificationStatus: (verified: boolean) => void;
  clearRegistrationData: () => void;
  getTierName: () => string;
}

export const useRegistrationStore = create<RegistrationStore>()(
  persist(
    (set, get) => ({
      registrationData: null,

      setRegistrationData: (data: Partial<RegistrationData>) => {
        set((state) => ({
          registrationData: {
            ...state.registrationData,
            ...data,
          } as RegistrationData,
        }));
      },

      updateEmailVerificationStatus: (verified: boolean) => {
        set((state) => ({
          registrationData: state.registrationData
            ? {
                ...state.registrationData,
                emailVerified: verified,
              }
            : null,
        }));
      },

      clearRegistrationData: () => {
        set({ registrationData: null });
        // Also clear localStorage verification flag
        localStorage.removeItem('email_verification_status');
      },

      getTierName: () => {
        const tierId = get().registrationData?.selectedTierId;
        switch (tierId) {
          case 1:
            return 'Starter';
          case 2:
            return 'Growth';
          case 3:
            return 'Professional';
          default:
            return 'Unknown';
        }
      },
    }),
    {
      name: 'registration-storage',
    }
  )
);
